/*  导航数据 */
export default {
    state:{
        menuData: []
    },
    mutations:{
    },
    actions:{

    },
    getters:{
    },
}



// WEBPACK FOOTER //
// ./src/store/NavMenu.js